import * as Sentry from "@sentry/react";
import { browserTracingIntegration } from "@sentry/browser";
import { createRoot } from "react-dom/client";
import TagManager from "react-gtm-module";
import App from "./App";
import { frontendBuild } from "./buildVersion";
import { updateClientAtStartup } from "./clientUpdate";

const unsupportedBrowser = window.__SELLAR_UNSUPPORTED_BROWSER__;

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [browserTracingIntegration()],
    environment: import.meta.env.VITE_ENV,
    release: frontendBuild?.release,
    initialScope: {
      tags: {
        "client.version": frontendBuild?.version,
        "client.commit": frontendBuild?.commit,
      },
    },
    tracesSampleRate: 1.0,
  });
}

if (unsupportedBrowser) {
  if (!import.meta.env.DEV && !unsupportedBrowser.forced) {
    Sentry.withScope((scope) => {
      scope.setTag("unsupported_browser", "true");
      scope.setContext("unsupported_browser", {
        reasons: unsupportedBrowser.reasons,
        userAgent: unsupportedBrowser.userAgent,
        browserName: unsupportedBrowser.browserName,
        browserVersion: unsupportedBrowser.browserVersion,
      });
      Sentry.captureMessage("Unsupported browser blocked", "warning");
    });
  }
} else {
  void (async () => {
    if (await updateClientAtStartup()) return;
    TagManager.initialize({
      gtmId: import.meta.env.VITE_GTM_ID,
    });

    const container = document.getElementById("root");
    const root = createRoot(container!);
    root.render(<App />);
  })();
}
